import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Styles/style'

const CandidateStatusFilter = ({ candidateStatus, setCandidateStatus }) => {
  const statusOptions = [
    {
      label: 'Shortlisted',
      value: 1,
    },
    {
      label: 'Rejected',
      value: -1,
    },
  ]

  return (
    <Wrapper column>
      <FilterCheckBoxComp
        value={candidateStatus}
        options={statusOptions}
        onChange={values => setCandidateStatus([values[values?.length - 1]])}
      />
    </Wrapper>
  )
}

export default CandidateStatusFilter
